import { z } from 'zod';
import { isoUtcDateTimeSchema } from '../date-time-schema';
import { itemCustomFieldValueSchema } from './custom-field-values-dto';
import { itemDependencySchema } from './dependency-dto';
import { estimationSchema } from './estimation-dto';
import { itemScheduleDatesSchema, schedulingTypeSchema } from './item-schedule-dto';

export const itemSchema = z.object({
  id: z.number().int().positive(),
  name: z.string().optional(),
  priority: z.string(),
  timeSpentSeconds: z.number().int().optional(),
  schedulingType: schedulingTypeSchema.optional(),
  description: z.string().optional(),
  targetStartDateTime: isoUtcDateTimeSchema.optional(),
  targetFinishDateTime: isoUtcDateTimeSchema.optional(),
  plannedStartDateTime: isoUtcDateTimeSchema.optional(),
  plannedFinishDateTime: isoUtcDateTimeSchema.optional(),
  schedules: itemScheduleDatesSchema.optional(),
  doneDateTime: isoUtcDateTimeSchema.optional(),
  dependencies: z.array(itemDependencySchema),
  estimationSchema: estimationSchema.nullable().optional(),
  createdAt: isoUtcDateTimeSchema.optional(),
  updatedAt: isoUtcDateTimeSchema.optional(),
  createdBy: z.string(),
  updatedBy: z.string(),
  itemTypeId: z.number().int().positive(),
  itemStatusId: z.number().int().positive(),
  parentId: z.number().int().positive().optional(),
  teamId: z.number().int().positive().optional(),
  estimationId: z.number().int().positive().optional(),
  customFields: z.record(z.string(), itemCustomFieldValueSchema).optional(),
  boxId: z.number().int().positive(),
  externalKey: z.string().nullable().optional(),
  externalLink: z.string().nullable().optional(),
  externalCreatedAt: isoUtcDateTimeSchema.optional(),
  planId: z.number().int().positive().optional(),
});

export const itemBulkFetchItemSchema = itemSchema.partial().required({ id: true });
export const itemBulkFetchSystemFieldSchema = itemBulkFetchItemSchema
  .omit({ customFields: true })
  .keyof();

export const itemBulkFetchItemsByIdSchema = z.record(z.string(), itemBulkFetchItemSchema);

export const itemBulkFetchMetadataSchema = z.object({
  missingItemIds: z.array(z.number().int().positive()),
  missingCustomFieldIds: z.array(z.number().int().positive()),
});

export const itemBulkFetchResponseSchema = z.object({
  itemsById: itemBulkFetchItemsByIdSchema,
  metadata: itemBulkFetchMetadataSchema,
});

export type ItemDTO = z.infer<typeof itemSchema>;
export type ItemBulkFetchItemDTO = z.infer<typeof itemBulkFetchItemSchema>;
export type ItemBulkFetchSystemFieldDTO = z.infer<typeof itemBulkFetchSystemFieldSchema>;
export type ItemBulkFetchItemsByIdDTO = z.infer<typeof itemBulkFetchItemsByIdSchema>;
export type ItemBulkFetchMetadataDTO = z.infer<typeof itemBulkFetchMetadataSchema>;
export type ItemBulkFetchResponseDTO = z.infer<typeof itemBulkFetchResponseSchema>;
